module.exports = __webpack_public_path__ + "static/media/2_n.cc39e3bb.jpg";